var description_default = {
  "subtitle": "u6wuf",
  "descriptionItem": "glG4C"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
